<template>
  <div class="node-icon">
    <img src="/img/camera.png" :width="size" :height="size">
  </div>
</template>

<script>
export default {
  name: "CameraIcon",
  props: {
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>
